import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface DeleteRequest {
    list_no: string;
}

interface DeleteResponse {
    statusCode: number;
    message: string;
}

export const useDeleteRequest = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const res = await axiosInstance.delete(enum_api_uri.delete_request, {
                data: body,
            });
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["usePostRequestList"] });
            onSuccessCallback?.();
        },
    });
};
